import type { FC } from 'react';
import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { FilterSection, StyledFieldset, StyledLegend } from './styles';
import { FilterTag, Wrapper } from '../button/filterTag';
import { useUniversalState } from '../../context/UniversalStateContext';
import type { Carline } from '../../utils/filterUtils';

type Props = {
  flattenedCarlines: Carline[];
  filteredCarlines: Carline[];
  selectedBodyTypes: string[];
  onClick: (id: string) => void;
  size: 'sm' | 'md';
};

export const basicBodyTypes: string[] = [
  'sportback',
  'sportscar',
  'sport',
  'suv',
  'limo',
  'avant',
  'aaq',
  'coupe',
  'cabrio',
  'allstreet',
  'spyder',
  'roadster',
  'compact',
  'citycarver',
  'allroad quatro',
];

export const BodyTypeFilterSection: FC<Props> = ({
  flattenedCarlines,
  filteredCarlines,
  selectedBodyTypes,
  onClick,
  size,
}) => {
  const { translations } = useUniversalState();

  const availableBodyTypes = basicBodyTypes.filter((type) =>
    flattenedCarlines.some((carline) => carline.bodyTypes?.includes(type)),
  );
  const fontSize = process.env.IS_LEGACY ? '2' : '3';

  return (
    <FilterSection>
      <StyledFieldset>
        <StyledLegend>
          <Text
            variant={{
              order: fontSize,
              style: 'normal',
              type: 'copy',
            }}
            tag="span"
            margin={[0, 0, 'var(--spacing-relative-2xs)', 0]}
          >
            {translations.filterBodytype}
          </Text>
        </StyledLegend>

        <Wrapper size={size}>
          {availableBodyTypes.map((id) => {
            const isSelected = selectedBodyTypes.includes(id);
            const isDisabled =
              !filteredCarlines.some((c) => c.bodyTypes?.includes(id)) && !isSelected;
            const labelText = translations[`bodyType.${id}`];

            return (
              <FilterTag
                key={id}
                id={id}
                text={labelText}
                onClickHandler={() => onClick(id)}
                selected={isSelected}
                disabled={isDisabled}
                dataTestId={`filterBodyType-${id.replace(/\s+/g, '')}`}
                size={size}
              />
            );
          })}
        </Wrapper>
      </StyledFieldset>
    </FilterSection>
  );
};
